
export function createRequestItemCards(request) {

    let cards = []

    request.equipmentRequestItemsForEquipmentRequest.forEach(item => {
        cards.push({
            id: item.id,
            name: item.equipment.name,
            sku: item.equipment.sku,
            requestedQty: item.requestedQuantity,
            shippedQty: item.sentQuantity
        })
    })

    return cards
}